import { render, staticRenderFns } from "./Petition.vue?vue&type=template&id=795f8de9&"
import script from "./Petition.vue?vue&type=script&lang=js&"
export * from "./Petition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports